import React, { useContext, useEffect, useState } from 'react'
import { useMutation, useQuery, useSubscription } from '@apollo/client'
import { AuthContext } from '../../Auth/AuthContext'
import { limitMaxNotification } from './Notifications'
import {
  COUNT_NOTIFICATIONS,
  NOTIFICATION_ADDED,
  USER_NOTIFICATIONS,
} from '../../graphql/Notifications/notifications'
import { EMPTY } from '../../graphql/Auth/auth'
import {
  GET_INTERNAL_NOTES,
  NOTIFY_INTERNAL_NOTES_SUBSCRIPTION,
} from '../../graphql/Catalog/InternalNotes/internalNotes'

const NotificationNavLink = ({ toggleSidebar, setTypeSidebar }) => {
  const { user } = useContext(AuthContext)

  //STATES
  const [count, setCount] = useState(null)

  //MUTATION
  const [emptyMutation] = useMutation(EMPTY)

  //QUERIES
  const { data, loading, error } = useQuery(COUNT_NOTIFICATIONS)

  //EFFECTS
  useEffect(() => {
    if (!loading) {
      if (error) setCount(null)
      setCount(!data.count ? null : data.count)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  const handleClick = () => {
    setTypeSidebar('Notifications')
    toggleSidebar()
  }

  useSubscription(NOTIFICATION_ADDED, {
    onData: async ({ data }) => {
      const dataResp = data?.data?.notificationAdd
      if (dataResp.some((item) => item?.id_user === user?.idUser)) {
        await emptyMutation({
          variables: {},
          refetchQueries: [
            { query: COUNT_NOTIFICATIONS },
            {
              query: USER_NOTIFICATIONS,
              variables: {
                limit: limitMaxNotification,
                offset: 0,
              },
            },
          ],
        })
      }
    },
  })

  useSubscription(NOTIFY_INTERNAL_NOTES_SUBSCRIPTION, {
    onData: async ({ data }) => {
      const dataResp = data?.data?.notifyInternalNotesSuscription
      if (dataResp?.document_id) {
        await emptyMutation({
          variables: {},
          refetchQueries: [
            {
              query: GET_INTERNAL_NOTES,
              variables: {
                document_id: dataResp?.document_id,
              },
              fetchPolicy: 'no-cache',
            },
          ],
        })
      }
    },
  })

  return (
    <li
      className="d-flex justify-content-center align-items-center dropdown mr-2"
      style={{ width: '30px', cursor: 'pointer' }}
      onClick={() => handleClick()}
    >
      <span className="nav-link">
        <i className="far fa-bell" style={{ fontSize: '23px' }} />
        {count && (
          <span className="badge badge-warning navbar-badge">{count}</span>
        )}
      </span>
    </li>
  )
}

export default NotificationNavLink
